import { FormCard, FormItem, TextArea } from '@lmc/ui-kit'
import type { CircumstanceSubsectionResponse } from '@lmc/validations'
import LastUpdateBox from 'components/carePlans/LastUpdateBox'
import { lastUpdateCarerFromUpdatedByData } from 'components/carePlans/lastUpdateCarerFromUpdatedByData'
import { RichTextFormField } from 'components/generic/richText/RichTextFormField'
import type { ResidentItemExtended } from 'hooks/useResident'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

export const CircumstancesFormCard = ({
  disabled,
  resident,
  richTextEnabled
}: {
  disabled?: boolean
  resident: ResidentItemExtended
  richTextEnabled?: boolean
}) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  return (
    <>
      <CircumstanceSubsectionFormCard
        disabled={disabled}
        namePath={['circumstances', 'socialCircumstances', 'description']}
        richTextEnabled={richTextEnabled}
        subsection={resident.circumstances?.socialCircumstances}
        title={t(supConstants.SOCIAL_CIRCUMSTANCES)}
      />
      <CircumstanceSubsectionFormCard
        disabled={disabled}
        namePath={['circumstances', 'educationalHistory', 'description']}
        richTextEnabled={richTextEnabled}
        subsection={resident.circumstances?.educationalHistory}
        title={t(supConstants.EDUCATIONAL_HISTORY)}
      />
      <CircumstanceSubsectionFormCard
        disabled={disabled}
        namePath={['circumstances', 'occupationalHistory', 'description']}
        richTextEnabled={richTextEnabled}
        subsection={resident.circumstances?.occupationalHistory}
        title={t(supConstants.OCCUPATIONAL_HISTORY)}
      />
    </>
  )
}

function CircumstanceSubsectionFormCard({
  disabled,
  namePath,
  richTextEnabled,
  subsection,
  title
}: {
  disabled?: boolean
  namePath: (string | number)[]
  richTextEnabled?: boolean
  subsection?: CircumstanceSubsectionResponse
  title: string
}) {
  return (
    <FormCard title={title}>
      <FormItem name={namePath}>
        {richTextEnabled ? (
          <RichTextFormField disabled={disabled} />
        ) : (
          <TextArea autoSize={{ minRows: 3 }} />
        )}
      </FormItem>
      {subsection?.updatedAt ? (
        <LastUpdateBox
          date={subsection.updatedAt}
          carer={lastUpdateCarerFromUpdatedByData(subsection.updatedByData)}
          noDateText=""
          style={{ paddingInline: 0 }}
        />
      ) : null}
    </FormCard>
  )
}
